import queryString from "query-string";
import findAndReplaceDOMText from "findandreplacedomtext";

// This must match the string in the licensekey shortcode
const DEFAULT_LICENSE = "[YOUR LICENSE KEY]";

export default class LicenseKey {
    getLicenseFromQueryString() {
        const parsed = queryString.parse(location.search);

        return parsed.licenseKey || null;
    }

    getLicenseFromStorage() {
        try {
            const singlestoreUser = JSON.parse(localStorage.getItem("singlestoreUser"));

            return singlestoreUser && (singlestoreUser.licenseKey || null);
        } catch (e) {
            return null;
        }
    }

    storeLicense(license) {
        try {
            if (license) {
                const singlestoreUser =
                    JSON.parse(localStorage.getItem("singlestoreUser")) || {};

                singlestoreUser.licenseKey = license;
                localStorage.setItem("singlestoreUser", JSON.stringify(singlestoreUser));
            }
        } catch (e) {
            return false;
        }
    }

    getLicense() {
        return this.getLicenseFromQueryString() || this.getLicenseFromStorage();
    }

    renderLicense(license) {
        if (license) {
            findAndReplaceDOMText(document.querySelector(".main"), {
                find: DEFAULT_LICENSE,
                replace: () => license,
            });
        }
    }

    mount() {
        const license = this.getLicense();

        this.renderLicense(license);
        this.storeLicense(license);
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/license-key.js